import { Component, EventEmitter, OnInit, Output, input } from '@angular/core';
import { Location, AsyncPipe } from '@angular/common';
import { faArrowAltCircleLeft, faHome } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { AppService } from '@Services/app.service';
import { TranslatePipe } from '../../../Shared/pipes/translate.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NavbarSearchComponent } from "../../../Shared/components/search/search-components/navbar-search/navbar-search.component";

@Component({
  selector: 'app-form-navigation',
  templateUrl: './form-navigation.component.html',
  styleUrls: ['../../form-layout/form-layout.component.scss'],
  imports: [FontAwesomeModule, RouterLink, AsyncPipe, TranslatePipe, NavbarSearchComponent],
})
export class FormNavigationComponent implements OnInit {
  faArrowAltCircleLeft = faArrowAltCircleLeft;
  faHome = faHome;
  window_title = '';
  previousUrl: string = '';
  currentUrl: string = '';
  system = 'life';
  readonly title = input<string>(undefined);
  readonly isModal = input<boolean>(undefined);
  @Output() close = new EventEmitter();
  constructor(
    public appS: AppService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private location: Location,
  ) {
    if (!this.isModal())
      this._router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          map(() => this._activatedRoute),
          map((route: any) => {
            while (route.firstChild) route = route.firstChild;
            return route;
          }),
          filter((route) => route.outlet === 'primary'),
          mergeMap((route: any) => route.data),
        )
        .subscribe((event: any) => {
          this.window_title = event['title']?.toString();
        });
  }

  ngOnInit(): void {}
  ngOnDestroy(): void {
    this.appS.showVerticalMenu.set(false);
  }
  goBack() {
    this.isModal() ? this.close.emit() : this.location.back();
  }
}
